import { client } from "stompjs";
import {
  DOWNLAOD_MULTIPLE_ASSET,
  DOWNLOAD_READY_ASSETS_API,
  UPDATE_BANDWIDTH,
} from "../Components/DAM_API/urls";
import Axios from "./Axios";
import { toast } from "react-toastify";

export const startDownloadAssets = async (_data) => {
  // debugger

  //     if (_data?.fileId?.length === 1) {
  //         const url = _data.files[0].ogUrl;

  //         const res = await fetch(url, {
  //             method: "GET",
  //         });

  //         if (!res.ok) {
  //             throw new Error("Download failed");
  //         }

  //         const blob = await res.blob();

  //         const filename =
  //             res.headers
  //                 .get("content-disposition")
  //                 ?.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/)?.[1] ||
  //             url.split("/").pop();

  //         const blobUrl = window.URL.createObjectURL(blob);

  //         // internal click – no redirect, no page change
  //         const tempLink = document.createElement("a");
  //         tempLink.style.display = "none";
  //         tempLink.href = blobUrl;
  //         tempLink.download = decodeURIComponent(filename);

  //         document.body.appendChild(tempLink);
  //         tempLink.click();
  //         document.body.removeChild(tempLink);

  //         window.URL.revokeObjectURL(blobUrl);
  //         return;
  //     }

  const response = await Axios.post(DOWNLAOD_MULTIPLE_ASSET, _data, {
    validateStatus: () => true,
  });

  // async job created
  if (response.status === 400) {
    toast.error(
      "Download is only allowed up to 5GBs. Please select fewer files or folders.",
    );
  }

  if (response.status === 202) {
    return {
      status: response.data?.status,
      downloadId: response.data?.requestId,
    };
  }

  // backend says ready immediately
  if (response.status === 200) {
    return {
      status: "READY",
      downloadId: response.data?.id,
    };
  }

  throw new Error("Failed to start download");
};

export const downloadAssetsFile = async (_data) => {
  const response = await Axios.get(
    `${DOWNLOAD_READY_ASSETS_API}/${_data.downloadId}?clientId=${window.Theme.clientId}`,
    {
      responseType: "blob",
    },
  );
  if (response.status !== 200) {
    throw new Error("File download failed");
  }

  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  const fileSizeMB = (blob.size / (1024 * 1024)).toFixed(2);

  // 🔥 send size to backend when download completes
  try {
    await Axios.post(UPDATE_BANDWIDTH, {
      downloadId: _data.downloadId,
      downloadBandWidth: fileSizeMB,
      clientId: window.Theme.clientId,
    });
  } catch (err) {
    console.error("Failed to notify backend", err);
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  let filename = "images.zip";
  const cd = response.headers["content-disposition"];
  if (cd) {
    const match = cd.match(/filename="(.+)"/);
    if (match) filename = match[1];
  }

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};
